import React, { Component } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import ModalDialog from '@atlaskit/modal-dialog';

import Toast from 'react-simple-toasts';

import { i18next, translate } from '../../base/i18n';
import { connect } from '../../base/redux';
import Loader from 'react-loader';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import axios from 'axios';
import Config from '../../customise/config';
const { socket_endpoint } = Config;

//import cross from './img/tutorial/cross.png';
import slide0 from './img/tutorial/slide0.gif';
import slide1 from './img/tutorial/slide1.gif';
import slide2 from './img/tutorial/slide2.gif';
import slide3 from './img/tutorial/slide3.gif';
import slide4 from './img/tutorial/slide4.gif';
import slide5 from './img/tutorial/slide5.gif';
import slide6 from './img/tutorial/slide6.gif';
import slide7 from './img/tutorial/slide7.gif';
import slide8 from './img/tutorial/slide8.gif';
import slide9 from './img/tutorial/slide10.gif';
import slide10 from './img/tutorial/slide11.gif';
import { FEATURE_CUSTOM_REDUX } from '../../customise/constant';
import { apiVersion } from "../../customise/welcome-dashboard/Utils";
import { messages } from '../../customise/welcome-dashboard/messages';
import { Constant } from '../constant';
import { Dialog, DialogContent, styled } from '@material-ui/core';
import { ct, webRoomNamePrefix } from '../../customise/constant-Utils';
import { Translate } from '../language';
import { getBaseConfig } from '../../customise/Utils';
import { PushSpinner } from '../../customise/custom/components/PushSpinner';

let timeoutFader, this_;

class Tutorial extends Component {

    constructor(props) {
        super(props);

        this.slideRef = React.createRef();
        this.slideMoreRef = React.createRef();
        this.slideNoRef = React.createRef();
        this.state = {
            ...this.state,
            position: 0,
            contactSupport: false,
            introButton: false,
            introComplete: false,
            noBtnText: ct("rta-trmc.tutorial.iDidBtn"),
            supportDescription: '',
            showHelpModal: false,
            showSupport: false,
            myLoader: false,

            ename: '',
            eemail: '',
            ephone: '',
            etime: '',
            ecomment: '',

            noHearDescription: '',
            noHearScreen: false,
            showNoBtn: false,
            clickNoBtn: false,
            showYesBtn: false,
            clickYesBtn: false,
            showMorePopUp: false,
            showNoPopUp: false,
            showFinalmsg: false,
            showOKBtn: false,
            showYesNoBtn: false,
            introSlidesState: [
                {
                    key: 0,
                    //title: 'Step 1',
                    url: slide0,
                    text: ct("rta-trmc.tutorial.slide0")
                },
                {
                    key: 1,
                    url: slide1,
                    text: ct("rta-trmc.tutorial.slide1")
                },
                {
                    key: 2,
                    url: slide2,
                    text: ct("rta-trmc.tutorial.slide2")
                },
                {
                    key: 3,
                    url: slide3,
                    text: ct("rta-trmc.tutorial.slide3")
                },
                {
                    key: 4,
                    url: slide4,
                    text: ct("rta-trmc.tutorial.slide4")
                },
                {
                    key: 5,
                    url: slide5,
                    text: ct("rta-trmc.tutorial.slide5")
                },
                {
                    key: 6,
                    url: slide6,
                    text: ct("rta-trmc.tutorial.slide6")
                },
                {
                    key: 7,
                    url: slide7,
                    text: ct("rta-trmc.tutorial.slide7")
                },
                {
                    key: 8,
                    url: slide8,
                    text: ct("rta-trmc.tutorial.slide8")
                },
                {
                    key: 9,
                    url: slide9,
                    text: ct("rta-trmc.tutorial.slide9")
                },
                {
                    key: 10,
                    url: slide10,
                    text: ct("rta-trmc.tutorial.slide10")
                },
                {
                    key: 11,
                    //url: slide11,
                    text: ct("rta-trmc.tutorial.slide11")
                },
            ],
        }
    }

    // state = {
    //     usersArr: [],
    //     sliderReverbValue: 0,
    //     leftReverb: false,
    //     rightReverb: true,
    //     open: false,
    //     selectedIndex: sessionStorage.getItem("selectedIndex") ? parseInt(sessionStorage.getItem("selectedIndex")) : 1
    // }

    componentDidMount() {
        // const { usersData } = this.props;
        // const { users } = usersData;

        // this.setState({ 
        //     usersArr: users,
        //     sliderReverbValue: usersData.reverbLevel,
        //     leftReverb: usersData.leftReverb,
        //     rightReverb: !usersData.leftReverb,
        //     open: false,
        //     selectedIndex: parseInt(sessionStorage.getItem("selectedIndex"))
        // });
        this_ = this;
    }

    // componentDidUpdate(prevProps) {
    // }

    componentWillUnmount() {
    }

    sendDataToSocket(message) {
        sendData(message);
    }

    // onOpenModal = () => {
    //     this.setState({ open: true });
    // };

    // onCloseModal = () => {
    //     this.setState({ open: false });
    // };

    _closeHelpModal = () => {
        this.setState({ showHelpModal: false });
        this_.setState({
            showHelpModal: false,
            position: 0,
            introButton: false,
            introComplete: false
        });
    }

    back = () => {
        const { position } = this_.state;
        // if (position > 10) {
        //     this.setState({ introButton: false });
        // }
        if (position == 10) {
            this_.setState({ introComplete: false, introButton: true, noBtnText: ct('rta-trmc.tutorial.bootingUpBtn') });
        } else if (position == 11) {
            this_.setState({ introComplete: false, introButton: true, noBtnText: ct('rta-trmc.tutorial.readyToConnectBtn') });
        } else if (position == 12) {
            this_.setState({ introComplete: true, introButton: false });
        } else {
            this_.setState({ introComplete: false, introButton: false });
        }

        if (position != 0) {
            var index = position - 1;
            this_.setState({ position: index });
            this_.slideRef.current.goTo(index);
        }
    }

    nextIntro = () => {
        const { position } = this_.state;
        if (position == this_.state.introSlidesState.length - 1) {
            this_.setState({ showHelpModal: false });
            this.props.onClose();
            return;
        }

        var index = position + 1;
        this_.setState({ position: index });
        this_.slideRef.current.goTo(index);

        if (index == 9) {
            this_.setState({ introComplete: false, introButton: true, noBtnText: ct('rta-trmc.tutorial.bootingUpBtn') });
        } else if (index == 10) {
            this_.setState({ introComplete: false, introButton: true, noBtnText: ct('rta-trmc.tutorial.readyToConnectBtn') });
        } else if (index == 11) {
            this_.setState({ introComplete: true, introButton: false });
        } else {
            this_.setState({ introComplete: false, introButton: false });
        }
    }
    setImagesPath = (img) => {
        let finalImage = img;
        console.log("webRoomNamePrefix ", webRoomNamePrefix, "image ", img)
        if (img) {
            // if (webRoomNamePrefix) {
            finalImage = getBaseConfig("appReferrerUrl") + finalImage;
            // }
        }
        console.log("final image ", finalImage)
        return finalImage;
    }


    render() {
        //renderHelpModal = () => {

        const properties = {
            autoplay: false,
            canSwipe: true,
            arrows: false,
            indicators: true,
            onChange(oldIndex, newIndex) {
                this_.setState({ position: newIndex });
                if (newIndex == 11) {
                    this_.setState({ introComplete: true, introButton: false });
                } else if (newIndex == 9) {
                    this_.setState({ introComplete: false, introButton: true, noBtnText: ct('rta-trmc.tutorial.bootingUpBtn') });
                } else if (newIndex == 10) {
                    this_.setState({ introComplete: false, introButton: true, noBtnText: ct('rta-trmc.tutorial.readyToConnectBtn') });
                } else {
                    this_.setState({ introComplete: false, introButton: false });
                }
            }
        };

        const introSlides = [
            {
                key: 0,
                //title: 'Step 1',
                url: slide0,
                text: ct("rta-trmc.tutorial.slide0")
            },
            {
                key: 1,
                url: slide1,
                text: ct("rta-trmc.tutorial.slide1")
            },
            {
                key: 2,
                url: slide2,
                text: ct("rta-trmc.tutorial.slide2")
            },
            {
                key: 3,
                url: slide3,
                text: ct("rta-trmc.tutorial.slide3")
            },
            {
                key: 4,
                url: slide4,
                text: ct("rta-trmc.tutorial.slide4")
            },
            {
                key: 5,
                url: slide5,
                text: ct("rta-trmc.tutorial.slide5")
            },
            {
                key: 6,
                url: slide6,
                text: ct("rta-trmc.tutorial.slide6")
            },
            {
                key: 7,
                url: slide7,
                text: ct("rta-trmc.tutorial.slide7")
            },
            {
                key: 8,
                url: slide8,
                text: ct("rta-trmc.tutorial.slide8")
            },
            {
                key: 9,
                url: slide9,
                text: ct("rta-trmc.tutorial.slide9")
            },
            {
                key: 10,
                url: slide10,
                text: ct("rta-trmc.tutorial.slide10")
            },
            {
                key: 11,
                //url: slide11,
                text: ct("rta-trmc.tutorial.slide11")
            },
        ];

        const { onClose } = this.props;


        return (
            <BootstrapDialog
                className='start-up-wrapper'
                fullWidth={true}
                maxWidth="md"
                id='tutorial-modal'
                open={true}
                conferenceJoined={this.props.conferenceJoined}
            >
                <DialogContent dividers className='dialog-content-wrapper'>
                    {/* <Modal className="start-up-wrapper" onClose={onClose}> */}
                    <div className="custom-guide">
                        <div className="newDIv startup-div position-relative">
                            <span className="close g-close" onClick={onClose}>
                                <i className="cus-close"></i>
                            </span>

                            <div className="App startup">
                                <div className="start-up-slide-container">

                                    {/* {this._renderIntroItem(this.state.introSlidesState[this.state.position])} */}

                                    <Slide ref={this.slideRef} {...properties}>
                                        {introSlides.map((each, index) => (
                                            <div key={index} className="each-slide position-relative flex-column align-items-center text-center">
                                                {this.state.position != 0 &&
                                                    <span className="back-slide" onClick={this.back}>
                                                        <i className="fa fa-angle-left"></i>
                                                    </span>
                                                }

                                                {each.url ? <img src={this.setImagesPath(each.url)} className="img-fluid mt-4" /> : <div style={{ height: "290px" }}></div>}
                                                {/* <div className="stp-slide" style={{'backgroundImage': `url(${each.url})`}}></div> */}
                                                <div className="start-up-content mt-auto">
                                                    <p> {each.text}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </Slide>

                                    <div className="start-up-slide-container buttons buttonWrapper mb-3">
                                        {this.state.introComplete ?
                                            <div>
                                                <button className="start-up-ok st-btn w-100 mb-3" onClick={this.nextIntro}>
                                                    {ct("Translate.buttonTitle.okCaps")}
                                                </button>
                                            </div>
                                            :
                                            <div>
                                                {this.state.introButton ?
                                                    <div>
                                                        <button className="start-up-ok st-btn w-100 mb-3" onClick={this.nextIntro}>
                                                            {this.state.noBtnText}
                                                        </button>
                                                    </div>
                                                    :
                                                    <div>
                                                        <button className="start-up-ok st-btn w-100 mb-3" onClick={this.nextIntro}>
                                                            {ct("rta-trmc.tutorial.iDidBtn")}
                                                        </button>
                                                    </div>
                                                }
                                                <div>
                                                    <button className="start-up-no st-btn border-btn w-100" onClick={this.openSupportModal}>
                                                        {ct("rta-trmc.tutorial.helpWithThis")}
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                </div>
                            </div>

                            {this.state.supportPopUp && this.renderSupportPopUp()}
                        </div>
                    </div>
                    {/* </Modal> */}
                </DialogContent>
            </BootstrapDialog>
        )
    }


    openSupportLink() {
        //SEND EMAIL
        //window.open('mailto:support@realtimeaudio.com?subject=contact support');
        this_.setState({
            contactSupport: true,
            eemail: '',
            ephone: '',
            ename: '',
            etime: '',
            ecomment: ''
        });
    }

    openSupportModal = () => {
        if (this.state.position == 0) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc1") });
        } else if (this.state.position == 1) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc2") });
        } else if (this.state.position == 2) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc3") });
        } else if (this.state.position == 3) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc4") });
            // removed last line: Click here for a list of compatible class compliant audio interfaces.
        } else if (this.state.position == 4) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc5") });
        } else if (this.state.position == 6) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc6") });
        } else if (this.state.position == 7) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc7") });
        } else if (this.state.position == 8) {
            this_.setState({ supportDescription: ct("rta-trmc.tutorial.supportDesc8") });
        } else {
            this_.setState({ supportDescription: "" });
        }
        this_.setState({ supportPopUp: true });
    }

    closeSupportModal = () => {
        this_.setState({ supportPopUp: false, contactSupport: false });
    }

    renderSupportPopUp = () => {
        return (
            <BootstrapDialog
                className='start-up-wrapper'
                fullWidth={true}
                maxWidth="md"
                id='support-modal'
                open={true}
            >
                <DialogContent dividers className='dialog-content-wrapper'>
                    {/* // <Modal className="start-up-wrapper" onClose={this.closeSupportModal}> */}
                    {/* CUSTOM: ADD LOADER */}
                    <>
                        {getBaseConfig("showPushSpinnerLoader") ?
                            <div className="loader-text-container">
                                <div className='loader-wrapper'>
                                    <PushSpinner
                                        size={30}
                                        color="white"
                                        loading={this.state.myLoader}
                                        className={"loader-text-main"}
                                    />
                                </div>
                            </div>
                            :
                            <Loader
                                loaded={!this.state.myLoader}
                                options={{
                                    color: '#fff'
                                }}
                            > </Loader>
                        }
                    </>

                    <div className="custom-guide">
                        {this.state.contactSupport ?
                            <div>
                                {this._renderEmailForm()}
                            </div>
                            :
                            <div className="newDIv startup-div position-relative">
                                <span className="close g-close" onClick={this.closeSupportModal}>
                                    <i className="cus-close"></i>
                                </span>
                                <div className="App startup">
                                    <div className="start-up-slide-container">
                                        <div key={this.state.position} className="each-slide position-relative help-modal d-flex flex-column align-items-center text-center pt-3">
                                            <span className="back-slide" onClick={this.closeSupportModal}>
                                                <i className="fa fa-angle-left"></i>
                                            </span>

                                            <div className="guide-wrap help-guide">
                                                <div className="start-up-content mt-5 pt-5 text-left">
                                                    <h2 className="blue-head">{this.state.introSlidesState[this.state.position].text} </h2>

                                                    {this.state.supportDescription == "" ?
                                                        <div>
                                                            {this.state.position == 5 &&
                                                                <span>
                                                                    <p>{ct("rta-trmc.tutorial.instruction1")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction2")}: <a href='https://share-a-cart.com/get/DOVMU' target='_blank'>https://share-a-cart.com/get/DOVMU</a> </p>
                                                                    <p>{ct("rta-trmc.tutorial.instruction3")}: <a href='https://share-a-cart.com/get/5QET9' target='_blank'>https://share-a-cart.com/get/5QET9</a> </p>
                                                                    <p>{ct("rta-trmc.tutorial.instruction4")}: <a href='https://share-a-cart.com/get/OQSAK' target='_blank'>https://share-a-cart.com/get/OQSAK</a> </p>
                                                                </span>
                                                            }

                                                            {this.state.position == 9 &&
                                                                <span>
                                                                    <p>{ct("rta-trmc.tutorial.instruction5")}</p>

                                                                    <p> {ct("rta-trmc.tutorial.instruction6")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction7")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction8")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction9")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction10")}: <a href='https://share-a-cart.com/get/DOVMU' target='_blank'>https://share-a-cart.com/get/DOVMU</a> </p>
                                                                </span>
                                                            }

                                                            {this.state.position == 10 &&
                                                                <span>
                                                                    <p>{ct("rta-trmc.tutorial.instruction11")}</p>
                                                                    <p>{ct("rta-trmc.tutorial.instruction12")}:</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction13")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction14")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction15")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction16")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction17")} <a href='https://www.wikihow.com/Disable-Router-Firewall' target='_blank'>{ct("rta-trmc.dashboard.subscription.enterCouponCodeLink2")}</a> {ct("rta-trmc.tutorial.instruction17")}<a href='https://www.wikihow.com/Set-Up-Port-Forwarding-on-a-Router' target='_blank'>{ct("rta-trmc.dashboard.subscription.enterCouponCodeLink2")}</a> {ct("rta-trmc.tutorial.instruction18")}</p>

                                                                    <p>{ct("rta-trmc.tutorial.instruction19")}</p>
                                                                </span>
                                                            }
                                                        </div>
                                                        :
                                                        <p> {this.state.supportDescription} </p>
                                                    }
                                                </div>
                                            </div>

                                            <div className="start-up-slide-container buttons buttonWrapper mb-3">
                                                <button className="start-up-ok st-btn w-100 mb-3" onClick={this.closeSupportModal}>
                                                    {ct("Translate.buttonTitle.okCaps")}
                                                </button>
                                                <button className="start-up-no st-btn border-btn w-100" onClick={this.openSupportLink}>
                                                    {ct("rta-trmc.tutorial.contactSupportBtn")}
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {/* </Modal> */}
                </DialogContent>
            </BootstrapDialog>
        )
    }

    closeEmailForm = () => {
        this_.setState({ contactSupport: false });
    }

    handleChange = (event) => {
        const { name, value, } = event.target;
        this.setState({
            [name]: value,
        });
    };

    ValidateEmail = (mail) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return (true)
        }
        Toast(ct("messages.notvalidEmail", "messages"), Constant.App.ToastTime.LongCloseTime);
        return (false);
    };


    ValidateNumber = (num) => {
        if (/^([0-9\(\)\/\+ \-]*)$/.test(num)) {
            return (true)
        }
        Toast(ct("messages.notvalidPhone", "messages"), Constant.App.ToastTime.LongCloseTime);
        return (false);
    };


    sendEmail = (event) => {
        event.preventDefault();
        const { dispatch } = this.props;
        let { ename, eemail, ephone, etime, ecomment } = this.state;

        if (!ename) {
            Toast(ct("messages.requiredName", "messages"), Constant.App.ToastTime.LongCloseTime);
            return;
        }

        if (!eemail) {
            Toast(ct("messages.requiredEmail", "messages"), Constant.App.ToastTime.LongCloseTime);
            return;
        }

        if (!this.ValidateEmail(eemail)) {
            return;
        }

        if (!ephone) {
            Toast(ct("messages.requiredPhone", "messages"), Constant.App.ToastTime.LongCloseTime);
            return;
        }

        if (!this.ValidateNumber(ephone)) {
            return;
        }

        if (!etime) {
            Toast(ct("messages.requiredTime", "messages"), Constant.App.ToastTime.LongCloseTime);
            return;
        }

        if (!ecomment) {
            Toast(ct("messages.requiredComment", "messages"), Constant.App.ToastTime.LongCloseTime);
            return;
        }

        let mailOptions = {
            from: eemail,
            name: ename,
            phone: ephone,
            time: etime,
            comment: ecomment
        };

        this.setState({ myLoader: true });
        axios.post(`${socket_endpoint}/sendSupportEmail`, mailOptions, config).then(response => {
            if (response.data.status) {
                this.setState({ myLoader: false });
                Toast(ct("messages.emailSendSuccess", "messages"), Constant.App.ToastTime.LongCloseTime);
                this_.setState({ contactSupport: false });
            } else {
                this.setState({ myLoader: false });
                Toast(ct("messages.emailOrTextSendError", "messages"), Constant.App.ToastTime.LongCloseTime);
            }
        }).catch(error => {
            this.setState({ myLoader: false });
            Toast(ct("messages.contactTutorialAdmin", "messages"), Constant.App.ToastTime.LongCloseTime);
        });
    };

    _renderEmailForm = () => {
        let { ename, eemail, ephone, etime, ecomment } = this.state;

        return (

            <div className="newDIv startup-div position-relative">
                <span className="close g-close" onClick={this.closeEmailForm}>
                    <i className="cus-close"></i>
                </span>
                <div className="App startup">
                    <div className="start-up-slide-container">
                        <div className="each-slide position-relative help-modal d-flex flex-column align-items-center text-center pt-3">
                            <span className="back-slide" onClick={this.closeEmailForm}>
                                <i className="fa fa-angle-left"></i>
                            </span>

                            <form className="w-100" onSubmit={this.sendEmail} autoComplete="nope">
                                <div className="guide-wrap help-guide w-100 d-block mt-5 pt-5">
                                    <div className="contact-form" >
                                        <div>
                                            <label> {ct("rta-trmc.tutorial.form.name")} : </label>
                                            <input
                                                type='text' placeholder={ct("rta-trmc.tutorial.form.namePlaceholder")}
                                                title={ct("rta-trmc.tutorial.form.namePlaceholder")}
                                                className='form-control' id='ename' name='ename'
                                                value={ename} onChange={this.handleChange}
                                                autoComplete="new-password" required={true}
                                                onInput={F => F.target.setCustomValidity('')}
                                                onInvalid={(e) => e.target.setCustomValidity(ct("rta-trmc.tutorial.inputInvalidMessage"))}
                                                //pattern={ROOM_NAME_VALIDATE_PATTERN_STR} autoFocus={true}
                                                minLength='1'
                                            />
                                        </div>
                                        <div>
                                            <label> {ct("rta-trmc.tutorial.form.email")} : </label>
                                            <input
                                                type="text" placeholder={ct("rta-trmc.tutorial.form.emailPlaceholder")}
                                                className="form-control" id="eemail" name="eemail"
                                                value={eemail} onChange={this.handleChange}
                                                autoComplete="new-password" required={true}
                                                minLength='1'
                                                onInput={F => F.target.setCustomValidity('')}
                                                onInvalid={(e) => e.target.setCustomValidity(ct("rta-trmc.tutorial.inputInvalidMessage"))}
                                            />
                                        </div>
                                        <div>
                                            <label> {ct("rta-trmc.tutorial.form.phoneNumber")} : </label>
                                            <input
                                                type="text" placeholder={ct("rta-trmc.tutorial.form.phoneNumberPlaceholder")}
                                                className="form-control" id="ephone" name="ephone"
                                                value={ephone} onChange={this.handleChange}
                                                autoComplete="new-password" required={true}
                                                minLength='1' maxLength='20'
                                                onInput={F => F.target.setCustomValidity('')}
                                                onInvalid={(e) => e.target.setCustomValidity(ct("rta-trmc.tutorial.inputInvalidMessage"))}
                                            />
                                        </div>
                                        <div>
                                            <label> {ct("rta-trmc.tutorial.form.availableTime")} : </label>
                                            <input
                                                type="text"
                                                placeholder={ct("rta-trmc.tutorial.form.availableTimePlaceholder")}
                                                className="form-control" id="etime" name="etime"
                                                value={etime} onChange={this.handleChange}
                                                autoComplete="new-password" required={true}
                                                minLength='1' maxLength='20'
                                                onInput={F => F.target.setCustomValidity('')}
                                                onInvalid={(e) => e.target.setCustomValidity(ct("rta-trmc.tutorial.inputInvalidMessage"))}
                                            />
                                        </div>
                                        <div>
                                            <label> {ct("rta-trmc.tutorial.form.comment")} : </label>
                                            <textarea
                                                placeholder={ct("rta-trmc.tutorial.form.commentPlaceholder")}
                                                rows="6"
                                                className="form-control" id="ecomment" name="ecomment"
                                                value={ecomment} onChange={this.handleChange}
                                                autoComplete="new-password" required={true}
                                                minLength='1'
                                                onInput={F => F.target.setCustomValidity('')}
                                                onInvalid={(e) => e.target.setCustomValidity(ct("rta-trmc.tutorial.inputInvalidMessage"))}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="start-up-slide-container buttons buttonWrapper mb-3">
                                    <button className="start-up-ok st-btn w-100 mb-3" type="submit" value="SEND EMAIL"> {ct("rta-trmc.tutorial.form.sendMail")} </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        )
    };

    openNoHearScreen = () => {
        if (this.state.position == 8 || this.state.position == 9) {
            this_.setState({ noHearScreen: true });
        }
    }

    closeNoHearScreen = () => {
        this_.setState({ noHearScreen: false });
    }

    openMorePopUp = () => {
        //this_.setState({ showMorePopUp: true });

        const { position } = this.state;
        if (position == this.state.introSlidesState.length - 1) {
            this_.setState({ showMorePopUp: true });
            return;
        }
        var index = position + 1;
        this.setState({ position: index, introButton: true, introComplete: false, noBtnText: ct("rta-trmc.tutorial.readyToConnect") });
    }

    closeMorePopUp = () => {
        this_.setState({ showMorePopUp: false });
    }

    autoLast = () => {
        setTimeout(() => {
            this.slideMoreRef.current.goTo(5);
        }, SLIDE_TIME_OUT);
    }

    nextScreen = () => {
        this_.setState({ clickYesBtn: true });
        this.slideMoreRef.current.goNext();

        if (this.slideMoreRef.current.state.index == 5) {
            this.finalDone();
        }
    }

    nextCondition = () => {
        this_.setState({ clickYesBtn: true });

        this.slideMoreRef.current.goNext();
        setTimeout(() => {
            this.slideMoreRef.current.goTo(4);
            this.autoLast();
        }, SLIDE_TIME_OUT);
    }

    finalDone = () => {
        localStorage.setItem('ifFirstVisit', false);
        this_.setState({
            showHelpModal: false,
            showMorePopUp: false,
            //showNoPopUp: false
        });
    }

    renderMorePopUp = () => {

        const properties = {
            // duration: 3000,
            // transitionDuration: 300,
            autoplay: false,
            canSwipe: false,
            arrows: false,
            indicators: false
        };

        const slides = [
            {
                key: '10',
                text: ct("rta-trmc.tutorial.systemIsBooting")
            },
            {
                key: '11',
                text: ct("rta-trmc.tutorial.checkingInternet")
            },
            {
                key: '12',
                text: ct("rta-trmc.tutorial.checkingUpdate")
            },
            {
                key: '13',
                text: ct("rta-trmc.tutorial.latestVersion")
            },
            {
                key: '14',
                text: ct("rta-trmc.tutorial.pleaseWait")
            },
            {
                key: '15',
                text: ct("rta-trmc.tutorial.sysConnect")
            }
        ];

        return (
            <Modal className="help-slider-wrapper" onClose={this.closeNoPopUp}>
                <div className="custom-guide">
                    <div className="newDIv sm-slider-box alter" >
                        <span className="close" onClick={() => changePopupState('')}>
                        </span>
                        <div className="App slider-webtec">
                            <div className="slide-container top-sec">
                                <Slide ref={this.slideMoreRef} {...properties}>
                                    {slides.map((each, index) => (
                                        <div key={index} className="each-slide">
                                            {index != 3 && index != 5 &&
                                                <div className="dots-row">
                                                    <i></i>
                                                    <i></i>
                                                    <i></i>
                                                </div>
                                            }
                                            <div className="start-up-content txt-h">{each.text}</div>

                                            {index == 0 &&
                                                <div className="slide-container buttons buttonWrapper text-center">
                                                    <button className="st-btn border-btn white mr-3" onClick={this.openNoPopUp}> {ct("Translate.buttonTitle.noCaps")} </button>
                                                    <button className="st-btn green-btn ml-3" onClick={this.nextScreen}> {ct("Translate.buttonTitle.yesCaps")} </button>
                                                </div>
                                            }

                                            {index == 1 &&
                                                <div className="slide-container buttons buttonWrapper text-center">
                                                    <button className="st-btn border-btn white mr-3" onClick={this.openNoPopUp}> {ct("Translate.buttonTitle.noCaps")} </button>
                                                    <button className="st-btn green-btn ml-3" onClick={this.nextScreen}> {ct("Translate.buttonTitle.yesCaps")} </button>
                                                </div>
                                            }

                                            {index == 2 &&
                                                <div className="slide-container buttons buttonWrapper text-center">
                                                    <button className="st-btn border-btn white mr-3" onClick={this.openNoPopUp}> {ct("Translate.buttonTitle.noCaps")} </button>
                                                    <button className="st-btn green-btn ml-3" onClick={this.nextCondition}> {ct("Translate.buttonTitle.yesCaps")} </button>
                                                </div>
                                            }

                                            {index == 5 &&
                                                <div className="slide-container buttons buttonWrapper text-center">
                                                    <button className="start-up-ok st-btn green-btn" onClick={this.finalDone}> {ct("Translate.buttonTitle.okCaps")} </button>
                                                </div>
                                            }
                                        </div>
                                    ))}
                                </Slide>
                            </div>

                            {/* { this.state.showYesNoBtn ?
                  <div className="slide-container buttons buttonWrapper text-center">
                    <button className="st-btn border-btn white mr-3" onClick={this.openNoPopUp}> No </button>
                    <button className="st-btn green-btn ml-3" onClick={this.nextScreen}> Yes </button>
                  </div>
                  :
                  <div className="slide-container buttons buttonWrapper text-center">
                    { this.state.showOKBtn ?
                        <button className="skipleft" onClick={this.finalDone}> OK </button>
                        : null
                    }
                  </div>
                  } */}
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }

    openNoPopUp = () => {
        let i = this.slideMoreRef.current.state.index;

        //this_.setState({ showNoPopUp: true, clickNoBtn: true });
        if (i == 0) {
            //this.setState({ nohearmodal: false });
            // setTimeout(() => {
            //     this.setState({ renderMoreNoModal: true })
            // }, 200);
            var array = [
                {
                    key: '17',
                    text: ct("rta-trmc.tutorial.usbPlugged")
                },
                {
                    key: '18',
                    text: ct("rta-trmc.tutorial.headphonePlugged")
                },
                {
                    key: '19',
                    text: ct("rta-trmc.tutorial.audioInterfaceTurnOn")
                },
            ]
            this.setState({ moreNoSlides: array, showNoPopUp: true, clickNoBtn: true });
        }
        else if (i == 1) {
            var array = [
                {
                    key: '20',
                    text: ct("rta-trmc.tutorial.ethernetCablePluggedDirectly")
                },
                {
                    key: '21',
                    text: ct("rta-trmc.tutorial.ethernetCableInRTA")
                }
            ]
            this.setState({ moreNoSlides: array, showNoPopUp: true, clickNoBtn: true });
        }
        else if (i == 2) {
            var array = [
                {
                    key: '22',
                    text: ct("rta-trmc.tutorial.rebootRTA")
                }
            ]
            this.setState({ moreNoSlides: array, showNoPopUp: true, clickNoBtn: true });
        }
    }

    closeNoPopUp = () => {
        this_.setState({ showNoPopUp: false });
    }

    nextNoScreen = () => {
        // : SHOW/HIDE No something text Button in view
        if (this.slideNoRef.current.state.index == (this.state.moreNoSlides.length - 1)) {
            this_.setState({
                showNoPopUp: false,
                showMorePopUp: true
            });
        }
        this.slideNoRef.current.goNext();
    }

    renderNoPopUp = () => {

        let properties = {
            autoplay: false,
            canSwipe: false,
            arrows: false,
            indicators: true
        };

        return (
            <Modal className="help-slider-wrapper" onClose={this.closeNoPopUp}>
                <div className="custom-guide">
                    <div className="newDIv sm-slider-box alter" >
                        <div className="App slider-webtec">
                            <div className="slide-container top-sec bg">
                                <Slide ref={this.slideNoRef} {...properties}>
                                    {this.state.moreNoSlides.map((each, index) => (
                                        <div key={index} className="each-slide">
                                            <div className="start-up-content">{each.text}</div>
                                        </div>
                                    ))}
                                </Slide>
                            </div>

                            <div className="slide-container buttons buttonWrapper text-center">
                                <button className="start-up-ok st-btn green-btn" onClick={this.nextNoScreen}> {ct("Translate.buttonTitle.okCaps")} </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }

}

function _mapStateToProps(state) {
    return {
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
    };
}

export default translate(connect(_mapStateToProps)(Tutorial));

const BootstrapDialog = styled(Dialog)(({ theme }) => {
    return ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
        '& .MuiDialog-paper': {
            height: (props) => props.conferenceJoined ? "614px" : '590px',
            margin: '0px',
            backgroundColor: '#052336'

        },
        '& .MuiDialog-paperFullWidth': {
            width: 'calc(100% - 20px )'
        },
        '& .dialog-content-wrapper': {
            border: 'none'
        }
    })
});
